// Javascript goes here

// Import popper.js and bootstrap

// Import all from bootstrap
import { Popover } from "bootstrap";

//Import other scripts
import "./icons";
import "./parallax";
import "./video-showcase";
import "./scroll-spotlight";
import "./contact-form";
import "./navigation";
import "./imask";
import "./utm-pixel";

document.addEventListener("DOMContentLoaded", (event) => {
  const inputs = document.querySelectorAll(".listen-for-input");

  inputs.forEach((input) => {
    input.addEventListener("input", () => {
      // Enable popovers
      var popoverTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="popover"]')
      );
      var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new Popover(popoverTriggerEl);
      });
    });
  });

  // const javascriptLinks = document.querySelectorAll("a[href^='http']");
  // if (javascriptLinks) {
  //   Array.from(javascriptLinks)
  //     .filter((link) => link.hostname != window.location.hostname)
  //     .forEach((link) => (link.target = "_blank"));
  // }
  //the event occurred
});
